exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24i7u{-ms-flex-negative:0;flex-shrink:0;width:100%;padding:0 80px 10px 40px;margin-bottom:0;border:none;font-size:30px;font-weight:400;line-height:30px;-webkit-box-shadow:none;box-shadow:none;color:#595959;background-color:transparent;outline:none;border-radius:0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._24i7u{color:#b3b3b3}._15THs{width:750px;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-bottom:1px solid #d9d9d9;background-color:#fff;margin:auto;display:block;padding-top:20px}body.reader-night-mode ._15THs{border-color:#2e2e2e;background-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"editor-title": "_24i7u",
	"editor-title-writing-mode": "_15THs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/Editor/EditorTitle.scss
// module id = fJnz
// module chunks = 0